import React, { useState, useEffect } from "react";
import { addTask, getTaskGroups } from "../apis/tasks";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { InputLabel } from "@material-ui/core";
import FormControl from '@material-ui/core/FormControl';
import useStyles from './muistyles';
import TextField from "@material-ui/core/TextField";
import { STATUS } from "../constants";


export const CreateTaskForm = ({ processId, show, setShow, setTasksChangedTrigger }) => {
  const [optionSelected, setOptionSelected] = useState(false);
  const [taskGroups, setTaskGroups] = useState([]);
  const classes = useStyles();

  useEffect(() => {
    // console.log("Inside useEffect CreateTaskForm");
    let mounted = true;
    if (!show) {
      return
    }
    getTaskGroups().then((ug) => {
      console.log("display taskGroups");
      console.log(ug);

      if (mounted) {
        setTaskGroups(ug);
      }
    });
    return () => {
      console.log("CreateTaskForm is unmounted");
      mounted = false;
    };
  }, []);

  if (!show) {
    return "";
  }

  const handleClose = (event) => {
    console.log("Handle Close");
    setShow(false);
  };

  

  function closeModal() {
    setOptionSelected(false);
    setShow(false);
  }

  function onSubmit(event) {
    event.preventDefault();
    var task = {};
    task.taskName = event.target.taskName.value;
    task.description = event.target.description.value;
    task.priority = event.target.priority.value;
    task.userCount = event.target.userCount.value;
    task.endDate = event.target.endDate.value;
    task.costperhour = event.target.costperhour.value;
    task.status = STATUS.ACTIVE.string;
    console.log("Task Created " + JSON.stringify(task));

    addTask(task, processId)
    .then((response)=>{
      if(response.ok){
        return response.json();
      }else{
        console.error("Add task failed");
      }
    })
    .then((data)=>{
      console.log("add Task is successfull ");
      onSuccessAddTask();
    })
    .catch((err)=>{
      console.error(err.message);
      throw err;
    })

    
  }

  function onSuccessAddTask(){
    
    console.log("onSuccessAddTask");
    setShow(false);
    setTasksChangedTrigger(true);
  }

  function onChange(e) {
    console.log("Inside onChange");
    // task.taskGroup = e.target.value;
    setOptionSelected(true);
  }

  var classStyles = optionSelected ? "ipc" : "ipc createTaskSelect";
  console.log(classStyles);
  console.log(optionSelected);

 

  return (
    <div className="modal">
      <div class="modal-content">
        <form onSubmit={onSubmit}>
          <div>
            <h1 style={{ fontSize: "x-large", color: "black" }}>Add Task</h1>
            <input
              type="text"
              className="ipc"
              placeholder="Enter Task Name"
              name="taskName"
              required
            />
            <input
              type="text"
              className="ipc"
              placeholder="Enter Description"
              name="description"
              required
            />
            <input
              type="date"
              className="ipc"
              placeholder="Enter End Date"
              name="endDate"
              required
            />
             
            <select id="priority" name="priority" className="ipc" defaultValue="CRITICAL" required >
              <option value="" disabled selected >Select Priority</option>
              <option value="CRITICAL" >CRITICAL</option>
              <option value="HIGH">HIGH</option>
              <option value="MEDIUM">MEDIUM</option>  
              <option value="LOW">LOW</option>      
            </select>
           
          
           
            <input
              type="text"
              className="ipc"
              className="ipc"
              placeholder="Enter Number of Users working on this task"
              name="userCount"
              required
             
              
            />
        

              <input
              type="text"
              className="ipc"
              placeholder="Enter Cost of Worker Per Hour"
              name="costperhour"
              required
            />

         
          </div>
          <div className="clearfix">
            <div className="row">
              <div className="col">
                <button className="ipc dialogbtn" onClick={closeModal}>
                  Cancel
                </button>
              </div>
              <div className="col">
                <button type="submit" className="ipc dialogbtn">
                  Add Task
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
